import React from 'react';
import { DashboardLayout } from '../components/DashboardLayout';
import { WhatsAppManagementDashboard } from '../components/whatsapp/WhatsAppManagementDashboard';
import { motion } from 'framer-motion';

export const WhatsAppManagementPage: React.FC = () => {
  return (
    <DashboardLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <WhatsAppManagementDashboard />
      </motion.div>
    </DashboardLayout>
  );
}; 